import { render, staticRenderFns } from "./MLAList.vue?vue&type=template&id=11173f63&scoped=true"
import script from "./MLAList.vue?vue&type=script&lang=js"
export * from "./MLAList.vue?vue&type=script&lang=js"
import style0 from "./MLAList.vue?vue&type=style&index=0&id=11173f63&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11173f63",
  null
  
)

export default component.exports